/**
 * Created by mac on 12/11/20
 */

const Families = {};

Families.initialize = function () {
    const LocationLines = [{
        a: 15,
        b: 7,
        c: 14,
        d: 7,
        e: 10,
        f: 7,
        g: 11,
        h: 7,
        i: 12,
        o: 10,
        p: 10,
        q: 10,
        r: 6,
        s: 10,
        t: 10,
        u: 10
    }];

    LocationLines.forEach((locationLine) => {
        Object.keys(locationLine).forEach((line) => {
            Families[line] = FamiliesHelper.ResourceFamily(locationLine[line], {
                sideQuest: ["o", "p", "q", "r", "s", "t", "u"].includes(line)
            });
        });
    });

    Families.unknown = FamiliesHelper.SpecialUnitFamily({
        unmergeable: true,
        movable: false
    }, {
        localization: false
    });

    Families.pp = FamiliesHelper.ValuableFamily("pp", {
        amounts: LinesRewards.energy,
        collectible: { rewardType: "energy" }
    });
    Families.rr = FamiliesHelper.ValuableFamily("rr", {
        amounts: LinesRewards.rubies,
        collectible: { rewardType: "rubies" }
    });
    Families.qq = FamiliesHelper.ValuableFamily("qq", {
        amounts: LinesRewards.orderStar,
        collectible: { rewardType: "orderStar" }
    });

    Families.AB = FamiliesHelper.GeneratorFamily({
        code: "AB",
        stages: 11
    });

    Families.CD = FamiliesHelper.GeneratorFamily({
        code: "CD",
        stages: 11
    });

    Families.E = FamiliesHelper.GeneratorFamily({
        code: "E",
        stages: 11
    });

    Families.Z = FamiliesHelper.GeneratorFamily({
        code: "Z",
        stages: 5
    });

    Families.F = FamiliesHelper.GeneratorFamily({
        code: "F",
        stages: 10

    });
    Families.GH = FamiliesHelper.GeneratorFamily({
        code: "GH",
        stages: 11

    });
    Families.I = FamiliesHelper.GeneratorFamily({
        code: "I",
        stages: 11
    });

    Families.O = FamiliesHelper.GeneratorFamily({
        code: "O",
        stages: 7,
        sideQuest: true
    });

    Families.P = FamiliesHelper.GeneratorFamily({
        code: "P",
        stages: 7,
        sideQuest: true
    });

    Families.QR = FamiliesHelper.GeneratorFamily({
        code: "QR",
        stages: 7,
        sideQuest: true
    });

    Families.SS = FamiliesHelper.GeneratorFamily({
        code: "SS",
        stages: 1,
        sideQuest: true
    });

    Families.S = FamiliesHelper.GeneratorFamily({
        code: "S",
        stages: 4,
        sideQuest: true
    });

    Families.T = FamiliesHelper.GeneratorFamily({
        code: "T",
        stages: 1,
        sideQuest: true
    });

    Families.U = FamiliesHelper.GeneratorFamily({
        code: "U",
        stages: 1,
        sideQuest: true
    });

    Families.thirdelement = FamiliesHelper.ThirdElementUnitFamily();

    Families.aa = FamiliesHelper.EnergyCupFamily(2, {
        code: "aa"
    });

    Families.bb = FamiliesHelper.EnergyCupFamily(2, {
        code: "bb"
    });

    Families.cc = FamiliesHelper.EnergyCupFamily(3, {
        code: "cc"
    });

    Families.dd = FamiliesHelper.EnergyCupFamily(3, {
        code: "dd"
    });

    Families.ee = FamiliesHelper.EnergyCupFamily(1, {
        code: "ee"
    });

    Families.ff = FamiliesHelper.EnergyCupFamily(8, {
        code: "ff",
        unmergeable: true
    });

    Families.uu = FamiliesHelper.EnergyCupFamily(1, {
        code: "uu"
    });

    Families.xx = FamiliesHelper.EnergyCupFamily(5, {
        code: "xx",
        unmergeable: true
    });

    Families.Ab = FamiliesHelper.EnergyCupFamily(3, {
        code: "Ab"
    });

    Families.Ei = FamiliesHelper.EnergyCupFamily(3, {
        code: "Ei"
    });

    Families.Cf = FamiliesHelper.EnergyCupFamily(3, {
        code: "Cf"
    });

    Families.Ai = FamiliesHelper.EnergyCupFamily(3, {
        code: "Ai",
        ordersOnly: true,
        openedOnly: true,
        unmergeable: true
    });

    Families.gg = FamiliesHelper.ChooseLineFamily(9, {
        code: "gg",
        unmergeable: true,
        choosesByStages: [
            [{ code: "e", stage: 5 }, { code: "f", stage: 5 }, { code: "b", stage: 4 }, { code: "c", stage: 7 }, { code: "a", stage: 7 }, { code: "g", stage: 5 }, { code: "d", stage: 4 }, { code: "i", stage: 5 }, { code: "h", stage: 4 }],
            [{ code: "a", stage: 5 }, { code: "g", stage: 3 }, { code: "h", stage: 4 }, { code: "c", stage: 5 }, { code: "d", stage: 3 }, { code: "f", stage: 3 }, { code: "i", stage: 3 }, { code: "e", stage: 3 }, { code: "b", stage: 3 }],
            [{ code: "a", stage: 5 }, { code: "g", stage: 3 }, { code: "h", stage: 4 }, { code: "c", stage: 5 }, { code: "d", stage: 3 }, { code: "f", stage: 3 }, { code: "i", stage: 3 }, { code: "e", stage: 3 }, { code: "b", stage: 3 }],
            [{ code: "a", stage: 6 }, { code: "c", stage: 6 }, { code: "e", stage: 4 }],
            [{ code: "g", stage: 4 }, { code: "h", stage: 3 }, { code: "i", stage: 4 }],
            [{ code: "g", stage: 5 }, { code: "h", stage: 4 }, { code: "i", stage: 5 }],
            [{ code: "a", stage: 7 }, { code: "c", stage: 7 }, { code: "e", stage: 5 }],
            [{ code: "F", stage: 0 }, { code: "GH", stage: 0 }, { code: "I", stage: 0 }],
            [{ code: "AB", stage: 0 }, { code: "CD", stage: 0 }, { code: "E", stage: 0 }]
        ]
    });

    Families.lr = FamiliesHelper.RainbowFamily(1, {
        code: "lr",
        unmergeable: true
    });

    Families.sc = FamiliesHelper.ScissorsFamily(1, {
        code: "sc",
        charges: 1
    });

    Families.am = FamiliesHelper.AmplifierFamily(3, {
        code: "am",
        charges: [5, 15, 35]
    });

    Families.ec = FamiliesHelper.EnergyCardFamily(4, {
        code: "ec",
        charges: [5, 15, 35, 85]
    });

    Families.pc = FamiliesHelper.PinFamily(1, {
        code: "pc",
        unmergeable: true
    });

    Families.hg = FamiliesHelper.HourglassFamily(5, {
        code: "hg",
        durations: [10, 20, 40, 80, 160],
        targets: ["AB", "CD", "E", "GH", "I", "O", "P", "F"]
    });

    Families.afterInitialize();
};

Families.afterInitialize = function () {
    if (cleverapps.config.debugMode && typeof exports === "undefined") {
        const unknown = cleverapps.dataLoader.load(DataLoader.TYPES.UNKNOWN_UNIT_TEST) || {};
        if (unknown.code !== undefined && unknown.stage !== undefined) {
            delete Families[unknown.code].units[unknown.stage];
        } else if (unknown.code) {
            delete Families[unknown.code];
        }
    }

    Families.codes = Object.keys(Families).filter((code) => typeof Families[code] === "object" && ["codes", "types"].indexOf(code) === -1);

    Families.types = {};

    Families.codes.forEach((code) => {
        const family = Families[code];
        family.code = code;
        family.expeditions = ["main"];

        if (family.type) {
            Families.types[family.type] = true;
        }
    });

    if (typeof window === "undefined" || cleverapps.config.debugMode) {
        Families.codes.forEach((code) => {
            if (/[^a-zA-Z0-9]/.test(code)) {
                throw `Invalid family code: ${code}. The family code must match the regex [a-zA-Z0-9]`;
            }
        });
    }

    Families.listSideQuestsLines = function () {
        return Families.codes.filter((code) => Families[code].type === "resource" && Families[code].sideQuest);
    };

    Families.listExpeditionCodes = function () {
        return cleverapps.createSet(Families.codes);
    };

    Families.processUnknown = function (data, knownFamilies) {
        const unknown = !Families[data.code] || !Families[data.code].units[data.stage] || !knownFamilies[data.code];
        if (unknown) {
            data = { code: "unknown", stage: 0, _data: data };
        }
        return data;
    };
};

if (typeof cc === "undefined") {
    module.exports = { Families };
}
